var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { applyCyAttribute } from "../../utils";
var EyeOff = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "64px", height: "64px", viewBox: "0 0 64 64", "enable-background": "new 0 0 64 64", xmlSpace: "preserve" }, props, applyCyAttribute('eyeOff-clickToHidePassword')),
        React.createElement("path", { fill: "none", stroke: color, "stroke-width": "2", "stroke-miterlimit": "10", d: "M1,32c0,0,11,15,31,15s31-15,31-15S52,17,32,17\n   S1,32,1,32z" }),
        React.createElement("circle", { fill: "none", stroke: color, "stroke-width": "2", "stroke-miterlimit": "10", cx: "32", cy: "32", r: "7" }),
        React.createElement("line", { fill: "none", stroke: color, "stroke-width": "2", "stroke-miterlimit": "10", x1: "9", y1: "55", x2: "55", y2: "9" })));
};
EyeOff.defaultProps = {
    color: '#000',
};
export default EyeOff;
//# sourceMappingURL=EyeOff.js.map